import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PROFILE } from "../../../constants/RoutesUrl.js";
import { BiEditAlt, BiRepost, BiUserVoice } from "react-icons/bi";
import { RiDeleteBinLine, RiEditLine } from "react-icons/ri";
import { AiOutlineUserAdd, AiOutlineUserDelete, AiOutlineRetweet } from "react-icons/ai";
import { MdOutlineReport } from "react-icons/md";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { IoChevronDown } from "react-icons/io5";
import { TbMailPlus } from "react-icons/tb";
import { FaRegShareFromSquare } from "react-icons/fa6";
import { BsBookmark, BsBookmarkFill } from "react-icons/bs";
import { RepostPollPopup } from "./PostFooter.jsx";
import "./PostHeaderDropdown.css";

const PostHeaderDropdown = ({
  postDetails,
  postDropDown,
  setPostDropDown,
  dropDownId,
  type,
  isSave,
  isShare,
  shares_count,
  isFollow,
  isOwner,
  user_id,
  lang,
  handleSave,
  handleRepost,
  handleFollow,
  setReportModal,
  setEditModal,
  setDeleteModal,
  setShowPost,
  editWebinarTab,
  editPostTab,
  setEditPost,
  editPost,
  handlePostSelect,
  setInviteWebinar,
  setWebinarType,
  setShareModal,
  setIsOpen,
  isOpen,
  toggleRepostModal,
  setEditPostInput,
  from,
  closeDetailModal
}) => {
  const collapseRef = useRef(null);
  const RepostbuttonRef = useRef(null);
  const [ignoreNextOutsideClick, setIgnoreNextOutsideClick] = useState(false);
  const [quoteModalOpen, setQuoteModalOpen] = useState(false);

  const pid = postDetails?.original_id || postDetails?.id;
  const isPoll = type === "poll" || postDetails?.type === "poll" || Boolean(postDetails?.option_1);
  const isReposted = Boolean(isShare || postDetails?.isShare);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ignoreNextOutsideClick) {
        setIgnoreNextOutsideClick(false);
        return;
      }

      const isClickInsideCollapse = collapseRef.current?.contains(event.target);
      const dotsButton = document.querySelector(".dots-button");
      const isClickInsideDotsButton = dotsButton?.contains(event.target);
      const isClickInsidePopup = document.querySelector(".modal.d-block")?.contains(event.target);

      // Only close if the click is outside all relevant elements
      if (
        !isClickInsideCollapse &&
        !isClickInsideDotsButton &&
        !isClickInsidePopup
      ) {
        setIsOpen(false);
      }
    };

    if (postDropDown || isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [postDropDown, isOpen, ignoreNextOutsideClick, setIsOpen]);

  const handleMenuItemClick = (callback) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIgnoreNextOutsideClick(true);
    if (callback) callback();
  };

  const repostTitle = isOwner
    ? `${shares_count || 0} ${lang?.repost || "Reposts"}`
    : `${isReposted ? (lang?.reposted || "Reposted") : (lang?.repost || "Repost")}`;

  const handleRepostClick = (e) => {
    e.stopPropagation();
    if (!isPoll) {
      if (!isOwner) {
        handleRepost(pid);
      } else {
        toggleRepostModal(pid);
      }
    } else {
      if (isOwner) {
        toggleRepostModal(pid);
      } else {
        if (!isReposted) {
          setIsOpen(!isOpen);
        } else {
          handleRepost(pid);
        }
      }
    }
  };

  const isMenuOpen =
    postDropDown &&
    (postDetails?.original_id === dropDownId || postDetails?.id === dropDownId);
  if (!isMenuOpen) return null;

  return (
    <>
      <div
        ref={collapseRef}
        className="mr-post-dropdown-menu"
        onClick={(e) => {
          e.stopPropagation();
          setIgnoreNextOutsideClick(true);
        }}
      >
        {/* ── Webinar: Follow / Unfollow ── */}
        {type === "webinar" && !isOwner && (
          <button
            type="button"
            className={`mr-post-dropdown-item ${isFollow ? "mr-post-dropdown-item--danger" : ""}`}
            onClick={handleMenuItemClick(() => handleFollow(postDetails?.user?.id))}
          >
            <span className="mr-post-item-icon">
              {isFollow ? <AiOutlineUserDelete /> : <AiOutlineUserAdd />}
            </span>
            <span className="mr-post-item-label">
              {isFollow ? (lang?.unfollow || "Unfollow") : (lang?.follow || "Follow")}
            </span>
          </button>
        )}

        {/* ── Webinar: Owner Actions (Invites / Host) ── */}
        {type === "webinar" && isOwner && (
          <>
            <button
              type="button"
              className="mr-post-dropdown-item"
              onClick={handleMenuItemClick(() => setInviteWebinar(true))}
            >
              <span className="mr-post-item-icon">
                <TbMailPlus />
              </span>
              <span className="mr-post-item-label">
                {lang?.send_invites || "Send Invites"}
              </span>
            </button>
            <button
              type="button"
              className="mr-post-dropdown-item"
              onClick={handleMenuItemClick(() => {
                setInviteWebinar(true);
                setWebinarType("host");
              })}
            >
              <span className="mr-post-item-icon">
                <BiUserVoice />
              </span>
              <span className="mr-post-item-label">
                {lang?.set_host || "Set Host"}
              </span>
            </button>
          </>
        )}

        {/* ── Standard Post Actions: Save & Repost ── */}
        {type !== "webinar" && (
          <>
            <button
              type="button"
              className={`mr-post-dropdown-item ${isSave ? "mr-post-dropdown-item--saved" : ""}`}
              onClick={handleMenuItemClick(() => handleSave(pid))}
            >
              <span className="mr-post-item-icon">
                {isSave ? <BsBookmarkFill /> : <BsBookmark />}
              </span>
              <span className="mr-post-item-label">
                {isSave ? (lang?.saved || "Saved") : (lang?.save || "Save Post")}
              </span>
            </button>

            {/* Repost Button */}
            <button
              type="button"
              ref={RepostbuttonRef}
              className={`mr-post-dropdown-item ${isReposted ? "mr-post-dropdown-item--reposted" : ""}`}
              onClick={handleRepostClick}
            >
              <span className="mr-post-item-icon">
                <BiRepost size={20} />
              </span>
              <span className="mr-post-item-label">
                {repostTitle}
              </span>
              {isPoll && !isOwner && !isReposted && (
                <span className={`mr-post-item-chevron ${isOpen ? "is-expanded" : ""}`}>
                  <IoChevronDown size={14} />
                </span>
              )}
            </button>

            {/* ── Poll Repost Submenu (Inline Accordion Options) ── */}
            {isPoll && !isOwner && !isReposted && isOpen && (
              <div className="mr-post-dropdown-submenu">
                {/* Quote Repost Option */}
                <button
                  type="button"
                  className="mr-post-submenu-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    setQuoteModalOpen(true);
                  }}
                >
                  <span className="mr-submenu-item-icon">
                    <RiEditLine size={15} />
                  </span>
                  <div className="mr-submenu-item-text">
                    <span className="mr-submenu-title">
                      {lang?.repost_with_your_thoughts || "Quote Repost"}
                    </span>
                    <span className="mr-submenu-subtitle">
                      {lang?.repost_this_poll_with_your_thoughts || "Add thoughts & share"}
                    </span>
                  </div>
                </button>

                {/* Instant Repost Option */}
                <button
                  type="button"
                  className="mr-post-submenu-item"
                  onClick={(e) => {
                    e.stopPropagation();
                    handleRepost(pid);
                    setIsOpen(false);
                  }}
                >
                  <span className="mr-submenu-item-icon">
                    <AiOutlineRetweet size={15} />
                  </span>
                  <div className="mr-submenu-item-text">
                    <span className="mr-submenu-title">
                      {lang?.repost || "Instant Repost"}
                    </span>
                    <span className="mr-submenu-subtitle">
                      {lang?.repost_this_poll_without_your_thoughts || "Instantly repost to feed"}
                    </span>
                  </div>
                </button>
              </div>
            )}
          </>
        )}

        {/* ── Edit Post (Owner only) ── */}
        {postDetails?.user?.id === user_id && type !== "poll" && type !== "clinical-image" && postDetails?.status !== 1 && (
          <button
            type="button"
            className="mr-post-dropdown-item"
            onClick={handleMenuItemClick(() => {
              if (setEditPostInput) setEditPostInput(postDetails?.caption);
              if (setShowPost) setShowPost(true);
              if (handlePostSelect) handlePostSelect(postDetails);
              if (type === "webinar") {
                if (editWebinarTab) editWebinarTab(true);
              } else {
                if (editPostTab) editPostTab(true);
                if (setEditPost) setEditPost(true);
              }
              if (setPostDropDown) setPostDropDown(false);
              if (setIsOpen) setIsOpen(false);
            })}
          >
            <span className="mr-post-item-icon">
              <BiEditAlt />
            </span>
            <span className="mr-post-item-label">
              {lang?.edit || "Edit Post"}
            </span>
          </button>
        )}

        {/* ── About This Account ── */}
        <Link
          to={`${PROFILE}/${postDetails?.user?.id}`}
          className="mr-post-dropdown-item"
          onClick={() => {
            if (closeDetailModal) closeDetailModal(true);
          }}
        >
          <span className="mr-post-item-icon">
            <IoMdInformationCircleOutline />
          </span>
          <span className="mr-post-item-label">
            {lang?.about_this_account || "About this account"}
          </span>
        </Link>

        {/* ── Share ── */}
        <button
          type="button"
          className="mr-post-dropdown-item"
          onClick={handleMenuItemClick(() => setShareModal(true))}
        >
          <span className="mr-post-item-icon">
            <FaRegShareFromSquare />
          </span>
          <span className="mr-post-item-label">
            {lang?.share || "Share"}
          </span>
        </button>

        {/* ── Divider Before Destructive Actions ── */}
        <div className="mr-post-dropdown-divider" />

        {/* ── Delete (Owner) ── */}
        {postDetails?.user?.id === user_id && (
          <button
            type="button"
            className="mr-post-dropdown-item mr-post-dropdown-item--danger"
            onClick={handleMenuItemClick(() => setDeleteModal(true))}
          >
            <span className="mr-post-item-icon">
              <RiDeleteBinLine />
            </span>
            <span className="mr-post-item-label">
              {lang?.delete || "Delete Post"}
            </span>
          </button>
        )}

        {/* ── Report (Non-Owner) ── */}
        {postDetails?.user?.id !== user_id && (
          <button
            type="button"
            className="mr-post-dropdown-item mr-post-dropdown-item--danger"
            onClick={handleMenuItemClick(() => setReportModal(true))}
          >
            <span className="mr-post-item-icon">
              <MdOutlineReport />
            </span>
            <span className="mr-post-item-label">
              {lang?.report || "Report Post"}
            </span>
          </button>
        )}
      </div>

      {/* ── Quote Repost Modal for Polls ── */}
      {quoteModalOpen && (
        <RepostPollPopup
          isOpen={quoteModalOpen}
          onClose={() => {
            setQuoteModalOpen(false);
            setIsOpen(false);
          }}
          onPost={() => {
            setQuoteModalOpen(false);
            setIsOpen(false);
          }}
          pollData={postDetails}
          handleRepost={handleRepost}
        />
      )}
    </>
  );
};

export default PostHeaderDropdown;
